import AuditLogScreen from './audit-log';

export default AuditLogScreen;
